import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Providers } from './app/providers';
import './styles/index.css';

const originalWarn = console.warn;

console.warn = (...args) => {
  const [firstArg] = args;
  if (
    (typeof firstArg === 'string' &&
      firstArg.includes('An aria-label or aria-labelledby prop is required for accessibility.')) ||
    firstArg.includes('If you do not provide a visible label')
  ) {
    return;
  }

  originalWarn(...args);
};

// biome-ignore lint/style/noNonNullAssertion: <disabled>
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <Providers>
        <App />
      </Providers>
    </Router>
  </StrictMode>,
);
